const PLATFORM_TENANT_LIST_ROLES = new Set(['admin', 'superadmin']);
const PLATFORM_TENANT_SELECT_ROLES = new Set(['admin', 'superadmin', 'overseer']);

/** GET /api/v2/admin/tenants/list is limited to admin and superadmin. */
export function canRequestPlatformTenantList(role) {
  return PLATFORM_TENANT_LIST_ROLES.has(String(role || '').toLowerCase());
}

/**
 * Tenant admins stay on their own tenant. Platform roles may select another tenant.
 * A tenant admin never receives another tenant's id from this helper.
 */
export function tenantScopedResourceId({
  role,
  requestedTenantId = '',
  authorizedTenantId = '',
  dealerActive = false,
} = {}) {
  const normalized = String(role || '').toLowerCase();
  const requested = String(requestedTenantId || '').trim();
  const authorized = String(authorizedTenantId || '').trim();
  if (dealerActive || PLATFORM_TENANT_SELECT_ROLES.has(normalized)) {
    return requested || authorized;
  }
  if (normalized === 'tenant_admin') {
    return authorized || requested;
  }
  return authorized;
}
